/**
 * Separate exports for route context hooks to prevent static imports
 */

import { createContext, useContext } from "react";

export const ClientRouteContext = createContext<{
  clientId?: string;
}>({});

export const useClientRouteContext = () => useContext(ClientRouteContext);

export const CompanyRouteContext = createContext<{
  companyId?: string;
}>({});

export const useCompanyRouteContext = () => useContext(CompanyRouteContext);
